<template>
    <div class="bgw" style="padding: 0 15px;">
        <p style="font-size: 1.5rem;font-family: PingFangSC-Medium, sans-serif;padding: 1rem 0;">{{ helpDetail.title
        }}</p>
        <div v-html="helpDetail.body" class="ql-editor">
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                helpDetail: {}
            }
        },
        created() {
            this.helpDetail = {
                title: '',
                content: ''
            }
        },
        mounted() {
            this.$http.get('/rest/faq/detail?nid='+this.$route.params.nid).then(res=>{
                if (res.success){
                    this.helpDetail = res.data
                }
            })
        }
    }
</script>
<style>
    @import "../assets/css/app.css";
</style>
